module.exports = "/_next/static/images/teacher-1-ad1f00d35e3a775ae8c8961ad949602c.png";